(() => {



const config=window.TGE||{},root=config.root||'/';



const money=value=>new Intl.NumberFormat(config.locale||'en',{style:'currency',currency:config.currency||'INR',currencyDisplay:config.currencyCode?'code':'symbol'}).format(value/100);



const node=(tag,text,className)=>{const el=document.createElement(tag);if(text!==undefined)el.textContent=text;if(className)el.className=className;return el};



const request=async(url,options)=>{const response=await fetch(url,options);let result;try{result=await response.json()}catch{throw Error(config.error)}if(!response.ok)throw Error(result.description||result.message||config.error);return result};



const post=(url,body)=>request(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});



let opener;



function open(dialog,button){opener=button||document.activeElement;if(!dialog.open)dialog.showModal()}



function close(dialog){dialog.close();opener?.focus()}



document.querySelectorAll('dialog').forEach(dialog=>{dialog.querySelector('[data-dialog-close]')?.addEventListener('click',()=>close(dialog));dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close(dialog)}});dialog.addEventListener('close',()=>opener?.focus())});



function image(src,alt){const img=node('img');img.src=src;img.alt=alt||'';img.loading='lazy';return img}



function rewards(cart,target){const values=(config.rewards||[]).filter(r=>r.goal>0&&r.label).sort((a,b)=>a.goal-b.goal);const current=config.rewardBasis==='count'?cart.item_count:cart.total_price/100;values.forEach(reward=>{const row=node('div',reward.label,'reward-row'),bar=node('progress');bar.max=reward.goal;bar.value=Math.min(current,reward.goal);bar.setAttribute('aria-label',reward.label);row.append(bar,node('span',current>=reward.goal?'âœ“':config.rewardBasis==='count'?Math.ceil(reward.goal-current)+' '+config.quantity:money(Math.round((reward.goal-current)*100))));target.append(row)})}







function couponCodes(cart) {



  if (Array.isArray(cart.discount_codes)) return cart.discount_codes.filter(d => d.applicable === true).map(d => d.code);



  const applications = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(d => d.discount_application))];



  return [...new Set(applications.filter(d => d.type === 'discount_code').map(d => d.title))];



}



function couponPanel(cart, notice, draft) {



  const panel = node('section', undefined, 'cart-coupon');



  const label = node('label', 'Coupon code');



  label.htmlFor = 'TGE-CartCoupon';



  const row = node('div', undefined, 'cart-coupon-row');



  const input = node('input');



  input.id = 'TGE-CartCoupon'; input.name = 'discount'; input.type = 'text';



  input.placeholder = 'Enter coupon code'; input.autocomplete = 'off';



  input.autocapitalize = 'characters'; input.spellcheck = false;



  input.maxLength = 255; input.value = draft || '';



  input.setAttribute('aria-describedby', 'TGE-CartCouponStatus');



  const apply = node('button', 'Apply');



  apply.type = 'button';



  const status = node('p', notice?.text || '', 'cart-coupon-status');



  status.id = 'TGE-CartCouponStatus'; status.setAttribute('role', notice?.error ? 'alert' : 'status');



  status.dataset.state = notice?.error ? 'error' : 'success';



  input.setAttribute('aria-invalid', String(Boolean(notice?.error)));



  const existing = couponCodes(cart);



  const pills = node('div', undefined, 'cart-coupon-codes');



  const perform = async (codes, attempted, removing) => {



    if (panel.getAttribute('aria-busy') === 'true') return;



    panel.setAttribute('aria-busy', 'true');



    panel.querySelectorAll('input,button').forEach(control => control.disabled = true);



    status.textContent = removing ? 'Removing couponâ€¦' : 'Applying couponâ€¦';



    status.dataset.state = 'pending';



    try {



      const updated = await post(root + 'cart/update.js', { discount: codes.join(',') });



      const accepted = removing || couponCodes(updated).some(code => code.toLowerCase() === attempted.toLowerCase());



      const text = removing ? 'Coupon removed.' : accepted ? (updated.total_price < cart.total_price ? 'Coupon applied. Your total has been updated.' : 'Coupon applied. Shipping discounts are calculated at checkout.') : 'This code is not valid for your cart. Check the code and its conditions.';



      await cartRender(updated, { text, error: !accepted }, accepted ? '' : attempted);



      const next = document.getElementById('TGE-CartCoupon');



      if (!accepted) next?.focus({ preventScroll: true });



      else document.querySelector('#TGE-Cart .cart-coupon-row button')?.focus({ preventScroll: true });



    } catch (e) {



      status.textContent = e.message || config.error; status.dataset.state = 'error';



      status.setAttribute('role', 'alert');



      input.setAttribute('aria-invalid', 'true');



    } finally {



      panel.removeAttribute('aria-busy');



      panel.querySelectorAll('input,button').forEach(control => control.disabled = false);



    }



  };



  const submit = () => {



    const code = input.value.trim();



    if (!code || code.includes(',')) {



      status.textContent = code ? 'Enter one coupon code at a time.' : 'Enter a coupon code.';



      status.dataset.state = 'error'; status.setAttribute('role', 'alert');



      input.setAttribute('aria-invalid', 'true'); input.focus(); return;



    }



    if (existing.some(value => value.toLowerCase() === code.toLowerCase())) {



      status.textContent = 'This coupon is already applied.'; status.dataset.state = 'success';



      input.setAttribute('aria-invalid', 'false'); return;



    }



    perform([...existing, code], code, false);



  };



  apply.addEventListener('click', submit);



  input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); submit(); } });



  existing.forEach(code => {



    const remove = node('button', code + ' Ã—', 'cart-coupon-pill');



    remove.type = 'button'; remove.setAttribute('aria-label', 'Remove coupon ' + code);



    remove.addEventListener('click', () => perform(existing.filter(value => value.toLowerCase() !== code.toLowerCase()), '', true));



    pills.append(remove);



  });



  row.append(input, apply);



  panel.append(label, row, pills, status);



  return panel;



}







async function cartRender(cartOverride, couponNotice, couponDraft){const dialog=document.getElementById('TGE-Cart'),container=dialog.querySelector('[data-cart-body]'),error=dialog.querySelector('[data-cart-error]');error.textContent='';dialog.setAttribute('aria-busy','true');try{const cart=cartOverride||await request(root+'cart.js');container.replaceChildren();document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);if(!cart.items.length){container.append(node('p',config.empty));return}rewards(cart,container);cart.items.forEach(item=>{const row=node('div',undefined,'cart-line');if(item.image)row.append(image(item.image,item.product_title));const info=node('div'),link=node('a',item.product_title);link.href=item.url;info.append(link,node('p',item.variant_title||''),node('p',money(item.final_line_price)));Object.entries(item.properties||{}).filter(([key,value])=>!key.startsWith('_')&&value).forEach(([key,value])=>info.append(node('p',key+': '+value)));const label=node('label',config.quantity),quantity=node('input');quantity.type='number';quantity.min='0';quantity.value=item.quantity;quantity.setAttribute('aria-label',config.quantity+' '+item.product_title);label.append(quantity);info.append(label);quantity.addEventListener('change',async()=>{quantity.disabled=true;try{await post(root+'cart/change.js',{id:item.key,quantity:Number(quantity.value)});await cartRender()}catch(e){error.textContent=e.message;quantity.value=item.quantity}finally{quantity.disabled=false}});const remove=node('button',config.remove);remove.type='button';remove.addEventListener('click',async()=>{remove.disabled=true;try{await post(root+'cart/change.js',{id:item.key,quantity:0});await cartRender()}catch(e){error.textContent=e.message;remove.disabled=false}});info.append(remove);item.line_level_discount_allocations?.forEach(d=>info.append(node('p',d.discount_application.title+' âˆ’ '+money(d.amount))));row.append(info);container.append(row)});cart.cart_level_discount_applications.forEach(d=>container.append(node('p',d.title+' âˆ’ '+money(d.total_allocated_amount))));if(config.giftWrap){const panel=node('div',undefined,'gift-wrap-panel');if(config.wrapAvailable&&config.wrapVariant){const wrapped=cart.items.find(i=>String(i.variant_id)===String(config.wrapVariant)),wrap=node('button',wrapped?config.unwrapLabel:config.wrapLabel+' â€” '+money(config.wrapPrice),'text-link');wrap.type='button';wrap.addEventListener('click',async()=>{wrap.disabled=true;try{if(wrapped)await post(root+'cart/change.js',{id:wrapped.key,quantity:0});else await post(root+'cart/add.js',{items:[{id:config.wrapVariant,quantity:config.wrapQuantity||1}]});await cartRender()}catch(e){error.textContent=e.message;wrap.disabled=false}});panel.append(wrap)}if(config.giftMessage){const label=node('label',config.giftMessageLabel),message=node('textarea');message.maxLength=500;message.value=cart.attributes?.['Gift message']||'';label.append(message);panel.append(label);message.addEventListener('change',async()=>{try{await post(root+'cart/update.js',{attributes:{'Gift message':message.value}})}catch(e){error.textContent=e.message}})}container.append(panel)}container.append(couponPanel(cart,couponNotice,couponDraft));const label=node('label',config.note),note=node('textarea');note.value=cart.note||'';label.append(note);container.append(label);note.addEventListener('change',async()=>{try{await post(root+'cart/update.js',{note:note.value})}catch(e){error.textContent=e.message}});container.append(node('h3',money(cart.total_price)));const checkout=node('a',config.checkout,'button');checkout.href=root+'checkout';if(cart.items.some(item=>window.TGEPreorders?.[String(item.variant_id)]||item.properties?.['Purchase type']==='Pre-order booking deposit')){container.append(node('p','Pre-order amounts are booking deposits. The remaining balance is payable separately.'));const terms=document.getElementById('TGE-PreorderTerms').content.cloneNode(true);const accept=terms.querySelector('[data-preorder-accept]');checkout.classList.add('preorder-checkout');checkout.setAttribute('aria-disabled','true');accept.addEventListener('change',()=>checkout.setAttribute('aria-disabled',String(!accept.checked)));checkout.addEventListener('click',event=>{if(!accept.checked){event.preventDefault();accept.focus();accept.reportValidity()}});container.append(terms)}container.append(checkout)}catch(e){error.textContent=e.message}finally{dialog.removeAttribute('aria-busy')}}



function bind(rootElement){rootElement.querySelectorAll('form[action*="/cart/add"]').forEach(form=>{if(form.dataset.ajaxBound)return;form.dataset.ajaxBound='1';form.addEventListener('submit',async event=>{if(!form.reportValidity()){event.preventDefault();return}if(!config.cartDrawer||event.submitter?.name==='checkout')return;event.preventDefault();const button=event.submitter;button&&(button.disabled=true);const dialog=document.getElementById('TGE-Cart');try{const response=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form)});const data=await response.json();if(!response.ok)throw Error(data.description||config.error);open(dialog,button);await cartRender()}catch(e){const status=document.querySelector('[data-commerce-status]');status.classList.remove('visually-hidden');status.textContent=e.message;status.setAttribute('role','alert')}finally{button&&(button.disabled=false)}})});rootElement.querySelectorAll('[data-quick-view]').forEach(button=>{if(button.dataset.bound)return;button.dataset.bound='1';button.addEventListener('click',async()=>{const dialog=document.getElementById('TGE-Quick'),body=dialog.querySelector('[data-quick-body]'),error=dialog.querySelector('[data-quick-error]');body.replaceChildren();error.textContent='';open(dialog,button);dialog.setAttribute('aria-busy','true');try{const url=new URL(button.dataset.quickView,location.origin);url.pathname+='.js';const product=await request(url);if(product.tags.includes('Pre-order')){location.assign(product.url);return}const layout=node('div',undefined,'quick-layout'),details=node('div');if(product.featured_image)layout.append(image(product.featured_image,product.title));details.append(node('h2',product.title));const price=node('p'),sku=node('p',undefined,'product-sku'),form=node('form');form.method='post';form.action=root+'cart/add';const select=node('select');select.name='id';select.setAttribute('aria-label',config.viewProduct);product.variants.forEach(v=>{const option=node('option',v.title+' â€” '+money(v.price));option.value=v.id;select.append(option)});const quantity=node('input');quantity.name='quantity';quantity.type='number';quantity.setAttribute('aria-label',config.quantity);const add=node('button',config.add,'button');add.type='submit';const update=()=>{const variant=product.variants.find(v=>String(v.id)===select.value);price.textContent=money(variant.price);sku.textContent=variant.sku?'SKU: '+variant.sku:'';sku.hidden=!variant.sku;add.disabled=!variant.available;add.textContent=variant.available?config.add:config.sold;const rule=variant.quantity_rule||{};quantity.min=rule.min||1;quantity.step=rule.increment||1;quantity.value=quantity.min;if(rule.max)quantity.max=rule.max;else quantity.removeAttribute('max')};select.addEventListener('change',update);form.append(select,quantity,add);update();const full=node('a',config.viewProduct,'text-link');full.href=product.url;details.append(price,sku,form,full);layout.append(details);body.append(layout);bind(form.parentElement)}catch(e){error.textContent=e.message}finally{dialog.removeAttribute('aria-busy')}})});rootElement.querySelectorAll('[data-sticky-buy]').forEach(button=>{if(button.dataset.bound)return;button.dataset.bound='1';button.addEventListener('click',()=>{const form=button.closest('[data-product-section]').querySelector('.product-form');if(!form)return;const submit=form.querySelector('[name=add]');if(submit&&!submit.disabled)form.requestSubmit(submit)})});rootElement.querySelectorAll('[data-zoom-image] img').forEach(img=>{if(img.dataset.zoomBound)return;img.dataset.zoomBound='1';img.tabIndex=0;img.setAttribute('role','button');const show=()=>{const dialog=node('dialog',undefined,'commerce-dialog zoom-dialog'),closeButton=node('button',config.close);closeButton.type='button';dialog.append(closeButton,image(img.currentSrc||img.src,img.alt));document.body.append(dialog);closeButton.onclick=()=>dialog.close();dialog.addEventListener('close',()=>{img.focus({preventScroll:true});requestAnimationFrame(()=>{const animations=dialog.getAnimations();if(animations.length)Promise.allSettled(animations.map(animation=>animation.finished)).then(()=>dialog.remove());else dialog.remove()})},{once:true});dialog.showModal()};img.addEventListener('click',show);img.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();show()}})});rootElement.querySelectorAll('[data-pickup-url]').forEach(el=>{if(el.dataset.bound)return;el.dataset.bound='1';fetch(el.dataset.pickupUrl).then(r=>{if(!r.ok)throw Error();return r.text()}).then(html=>{const result=new DOMParser().parseFromString(html,'text/html').querySelector('[data-pickup-content]');if(result)el.replaceChildren(result)}).catch(()=>{})})}



document.addEventListener('click',event=>{const link=event.target.closest('a');if(!link)return;const url=new URL(link.href,location.origin);if(url.origin!==location.origin)return;if(url.pathname===root+'cart'&&config.cartDrawer){event.preventDefault();open(document.getElementById('TGE-Cart'),link);cartRender()}});



const query=document.querySelector('[data-predictive]');let timer,controller,sequence=0;



query?.addEventListener('input',()=>{clearTimeout(timer);controller?.abort();const results=document.getElementById('PredictiveResults'),current=++sequence;if(!query.value.trim()){results.replaceChildren();query.setAttribute('aria-expanded','false');return}timer=setTimeout(async()=>{controller=new AbortController();try{const url=new URL(root+'search/suggest.json',location.origin);url.search=new URLSearchParams({q:query.value,'resources[type]':'product,collection,page,article,query','resources[limit]':'6'});const data=await request(url,{signal:controller.signal});if(current!==sequence)return;results.replaceChildren();Object.values(data.resources.results).flat().forEach(result=>{const link=node('a',undefined,'predictive-link');link.href=result.url;if(result.featured_image?.url)link.append(image(result.featured_image.url,result.title));link.append(node('span',result.title||result.text));results.append(link)});if(!results.children.length)results.append(node('p',config.noResults));query.setAttribute('aria-expanded','true')}catch(e){if(e.name!=='AbortError')results.textContent=config.error}},200)});



const age=document.getElementById('TGE-Age');if(age){let passed=false;try{passed=sessionStorage.getItem('tge-age')==='1'}catch{}if(!passed)age.showModal();age.addEventListener('cancel',e=>e.preventDefault());age.querySelector('[data-age-confirm]').onclick=()=>{try{sessionStorage.setItem('tge-age','1')}catch{}age.close()}}



document.querySelector('[data-back-top]')?.addEventListener('click',()=>window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));



async function recent(){let handles=[];try{handles=JSON.parse(localStorage.getItem('tge-recent')||'[]').filter(h=>typeof h==='string'&&/^[a-z0-9-]+$/.test(h))}catch{}const current=document.querySelector('[data-product-handle]')?.dataset.productHandle;const grid=document.querySelector('[data-recent-grid]');if(grid){grid.replaceChildren();for(const handle of handles.filter(h=>h!==current).slice(0,4)){try{const response=await fetch(root+'products/'+handle+'?view=tge-card');if(!response.ok)continue;const html=await response.text(),card=new DOMParser().parseFromString(html,'text/html').querySelector('.product-card');if(card){grid.append(card);bind(card)}}catch{}}if(!grid.children.length)grid.closest('[data-recent-products]').hidden=true}if(current)try{localStorage.setItem('tge-recent',JSON.stringify([current,...handles.filter(h=>h!==current)].slice(0,12)))}catch{}}



bind(document);recent();document.addEventListener('shopify:section:load',event=>bind(event.target));



})();







(()=>{document.querySelectorAll('[data-promo-popup]').forEach(dialog=>{let last=0;try{last=Number(localStorage.getItem('tge-promo-'+dialog.dataset.key))}catch{}if(Date.now()-last<Number(dialog.dataset.frequency)*86400000)return;const timer=setTimeout(()=>{if(!document.querySelector('dialog[open]'))dialog.showModal()},Number(dialog.dataset.delay)*1000);const dismiss=()=>{try{localStorage.setItem('tge-promo-'+dialog.dataset.key,Date.now())}catch{}dialog.close()};dialog.querySelector('[data-popup-close]').onclick=dismiss;dialog.addEventListener('cancel',dismiss);document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(dialog))clearTimeout(timer)},{once:true})});const more=document.querySelector('[data-load-more]');if(more){let loading=false;const load=async()=>{if(loading||!more.href)return;loading=true;more.setAttribute('aria-busy','true');try{const response=await fetch(more.href);if(!response.ok)throw Error();const html=new DOMParser().parseFromString(await response.text(),'text/html'),grid=html.querySelector('[data-collection-grid]');if(!grid)throw Error();document.querySelector('[data-collection-grid]').append(...grid.children);document.dispatchEvent(new CustomEvent('shopify:section:load',{detail:{},bubbles:true}));const next=html.querySelector('[data-load-more]');if(next)more.href=next.href;else{more.remove();observer.disconnect()}}catch{more.textContent=window.TGE?.error||'Please try again'}finally{loading=false;more.removeAttribute('aria-busy')}};more.addEventListener('click',e=>{e.preventDefault();load()});const observer=new IntersectionObserver(entries=>{if(entries[0].isIntersecting)load()},{rootMargin:'200px'});observer.observe(more)}})();







(()=>{function setup(root){root.querySelectorAll('[data-option-pickers]').forEach(pickers=>{if(pickers.dataset.bound)return;pickers.dataset.bound='1';const section=pickers.closest('[data-product-section]'),variants=JSON.parse(section.querySelector('[data-product-variants]').textContent),select=section.querySelector('[data-variant-select]');let revision=0;pickers.addEventListener('change',()=>{const currentRevision=++revision;const values=[...pickers.querySelectorAll('fieldset')].map(field=>field.querySelector('input:checked')?.value);const variant=variants.find(v=>v.options.every((value,index)=>value===values[index]));const add=section.querySelector('[data-add]');if(!variant){add.disabled=true;section.querySelector('[data-add-text]').textContent=window.TGE.sold;return}select.value=String(variant.id);select.dispatchEvent(new Event('change',{bubbles:true}));const option=select.selectedOptions[0];const stock=section.querySelector('[data-stock]');if(stock)stock.textContent=option.dataset.stock;const media=section.querySelector('[id$="-'+option.dataset.media+'"]');if(media&&!section.querySelector('[data-gallery-target]'))media.scrollIntoView({block:'nearest',behavior:'smooth'});if(option.dataset.preorder==='true'&&variant.available)section.querySelector('[data-add-text]').textContent=window.TGE.preorder;const target=new URL(location.href);target.searchParams.set('variant',variant.id);target.searchParams.set('section_id',section.closest('[id^=shopify-section-]')?.id.replace('shopify-section-','')||'main-product');fetch(target).then(r=>r.text()).then(html=>{if(currentRevision!==revision)return;const doc=new DOMParser().parseFromString(html,'text/html'),pricing=doc.querySelector('[data-volume-pricing]'),pickup=doc.querySelector('[data-pickup-url]');if(pricing)section.querySelector('[data-volume-pricing]').innerHTML=pricing.innerHTML;if(pickup){const old=section.querySelector('[data-pickup-url]');if(old){old.replaceWith(pickup);document.dispatchEvent(new CustomEvent('shopify:section:load'))}}}).catch(()=>{})})})}setup(document);document.addEventListener('shopify:section:load',e=>setup(e.target))})();







(()=>{function bind(root){root.querySelectorAll('[data-bundle]').forEach(form=>{if(form.dataset.bound)return;form.dataset.bound='1';form.addEventListener('submit',async e=>{e.preventDefault();const items=[...form.querySelectorAll('[data-bundle-item]:checked:not(:disabled)')].map(input=>{const variant=input.parentElement.querySelector('[data-bundle-variant]').selectedOptions[0];return{id:Number(variant.value),quantity:Number(variant.dataset.quantity||1)}});if(!items.length)return;const button=form.querySelector('[type=submit]'),status=form.querySelector('[data-bundle-status]');button.disabled=true;try{const response=await fetch((window.TGE?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok)throw Error(result.description||window.TGE.error);location.assign((window.TGE?.root||'/')+'cart')}catch(error){status.textContent=error.message}finally{button.disabled=false}})})}bind(document);document.addEventListener('shopify:section:load',e=>bind(e.target))})();







(()=>{function bind(root){root.querySelectorAll('[data-recipient-toggle]').forEach(toggle=>{if(toggle.dataset.bound)return;toggle.dataset.bound='1';const fields=toggle.closest('.gift-recipient').querySelector('[data-recipient-fields]');const update=()=>{fields.hidden=!toggle.checked;fields.querySelectorAll('input,textarea').forEach(input=>input.disabled=!toggle.checked);fields.querySelector('[type=email]').required=toggle.checked;fields.querySelector('[data-recipient-offset]').value=new Date().getTimezoneOffset();const date=fields.querySelector('[type=date]'),today=new Date(),max=new Date();max.setDate(today.getDate()+90);date.min=today.toISOString().slice(0,10);date.max=max.toISOString().slice(0,10)};toggle.addEventListener('change',update);update()})}bind(document);document.addEventListener('shopify:section:load',e=>bind(e.target));const search=document.getElementById('TGE-Search'),suggestions=document.querySelector('[data-search-suggestions]');if(search&&suggestions){const copy=suggestions.cloneNode(true);copy.classList.remove('visually-hidden');copy.removeAttribute('data-search-suggestions');search.append(copy)}})();







(()=>{function bind(root){root.querySelectorAll('.card-hover-video video').forEach(video=>{if(video.dataset.bound)return;video.dataset.bound='1';const card=video.closest('.product-image-link');card.addEventListener('mouseenter',()=>{if(!matchMedia('(prefers-reduced-motion: reduce)').matches)video.play().catch(()=>{})});card.addEventListener('mouseleave',()=>video.pause())});root.querySelectorAll('[data-discount-form]').forEach(form=>{if(form.dataset.bound)return;form.dataset.bound='1';form.addEventListener('submit',e=>{e.preventDefault();const code=form.elements.discount.value.trim();if(code)location.assign((window.TGE.root||'/')+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent((window.TGE.root||'/')+'cart'))})})}bind(document);document.addEventListener('shopify:section:load',e=>bind(e.target))})();







(()=>{function bind(root){root.querySelectorAll('[data-comparison-range]').forEach(range=>{if(range.dataset.bound)return;range.dataset.bound='1';const comparison=range.closest('section').querySelector('[data-image-comparison]');range.addEventListener('input',()=>comparison.style.setProperty('--comparison',range.value+'%'))})}bind(document);document.addEventListener('shopify:section:load',e=>bind(e.target))})();



